import MainService from "@/services/MainService.js";

export default {
    name: "KardexPage",
    data() {
        let ss = new MainService();
        return {
            msg: "KardexPage",
            ss: ss,
            auth: {},
            rols: [],
            kardexs: [],
            errorBag: {},
            kardex: {},
            
        };
    },
    methods: {
        CapacitacionProfesional(){
            console.log('aqui estoy');
            this.$refs['CapacitacionProfesionalPage'].index();
            //this.$refs['indexCapacitacionProfesional'].hide();
        },
        
    },
    
   
};
